import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { environment } from '@src/environments/environment';
import { Project } from '@src/app/models/project';
import { Projectperson } from '../model/projectperson';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProjectnameService {

  constructor(private http:HttpClient) { }
  getProject(projectId:string){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.get<Project>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/project/'+projectId,httpOptions);
  }
  getPersonProjects(personId:string,orgId:string){
    // getPersonProjects(personId:string){
       const httpOptions = {
         headers: new HttpHeaders({
           'Content-Type': 'application/json',
           'Authorization': SessionHelper.getIdToken()
         })
       }
       return this.http.get<Project[]>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/projectperson/list/person/'+personId,httpOptions);
      }
}
